import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import AppMain from '../../main/AppMain';
import appStore, { appPersistor } from '../../main/AppStore';
import { darkTheme } from '../style/darkTheme';
import { AppContextProvider } from './AppContextProvider';

const AppCore = () => {

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24,
            },
        },
    })

    return <QueryClientProvider client={queryClient}>
        <StoreProvider store={appStore}>
            <PersistGate loading={null} persistor={appPersistor}>
                <ThemeProvider theme={darkTheme}>
                    <AppContextProvider defaultUrl='/' defaultLanguage='fr'>
                        <BrowserRouter>
                            <AppMain />
                        </BrowserRouter>
                    </AppContextProvider>
                </ThemeProvider>
            </PersistGate>
        </StoreProvider>
    </QueryClientProvider>

}

export default AppCore